<template lang="html">
    <div id="loader-container" v-if="this.$store.state.isLoading">
        <div id="loader">
            <img src="../../assets/images/oval.svg" alt="Loading Animation">
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style lang="css" scoped>
    #loader-container {
        width: 100vw;
        height: 100vh;
        min-width: 100vw !important;
        min-height: 100vh !important;
        max-width: 100vw !important;
        max-height: 100vh !important;
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(255, 255, 255, 0.9);
        z-index: 3000;
    }

    #loader {
        position: absolute;
        top: calc(40% - 20px);
        left: calc(50% - 20px);
        width: 40px;
        max-width: 40px;
        min-width: 40px;
        height: 40px;
        max-height: 40px;
        min-height: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Loader.vue